export default __webpack_public_path__ + "static/media/Mountain of Corpses.ec74be98.png";